'use client';

import { Box } from '@mui/material';
import { PAGE_LIST } from 'constant/pages';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { getKeyFromLocalStorage } from 'utils/constant';

export default function AppLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    const appId = getKeyFromLocalStorage('appId');
    const appKey = getKeyFromLocalStorage('appKey');
    if (!appId || !appKey) navigate(PAGE_LIST.SETTING.pathname());
  }, []);

  return (
    <Box
      sx={{
        height: '100vh',
      }}
    >
      <Outlet />
    </Box>
  );
}
